// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from '../ThemeContext'; // Custom theme context

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  const { darkMode } = useTheme();

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.add('light-mode');
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <nav className="navbar navbar-expand-md navbar-dark site-navbar">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="site-navbar-collapse"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse${isMenuOpen ? ' show' : ''}`} id="site-navbar-collapse">
          <ul className="navbar-nav me-auto mb-2 mb-md-0">
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/apps" onClick={closeMenu}>Apps</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/articles" onClick={closeMenu}>Articles</Link>
            </li>
          </ul>
          <a
            className="btn btn-secondary site-navbar__cta"
            href="https://sellers-records.talkabout.finance/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
          >
            <span>Free Vinted HMRC</span>
            <span className="site-navbar__cta-line">Seller Checklist</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
